import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=53f94c93&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=53f94c93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f94c93",
  null
  
)

export default component.exports